import { Container, Spinner } from "react-bootstrap";

export function SpinnerCurrent() {
  return (
    <Container className={"d-flex fs-39 justify-content-center"}>
      <Spinner animation="border" variant="danger" />
    </Container>
  );
}
